import axios from "axios"
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react"

import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
   ButtonGroup, Menu,
} from "@mui/material"
import WebService from "@util/webService"
import { encodeParams, findCode, getAction, printVariable } from "@util/helper"
// redux
import { useSelector, useDispatch } from "react-redux"
// MUI Table
import CssBaseline from "@mui/material/CssBaseline"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
// react-table
import { useTable, useExpanded } from "react-table"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import {GlobalStyle as gs} from "@src/GlobalStyle"
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Snackbar,
  TablePagination,
  TextField,
  withStyles,
  InputBase,
} from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import "@scss/App.scss"
import Button from "@mui/material/Button"
import FlatButton from "@components/FlatButton"
import useSnackbar from "@hooks/useSnackbar"
import MyTableHead from "@components/MyTableHead"
import useIndicator from "@hooks/useIndicator"
import Indicator from "@components/Indicator"
import MyDialog from "@components/MyDialog"
import useForm from "@hooks/useForm"
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
// pagination
import { useTheme } from "@mui/material/styles"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"
import LastPageIcon from "@mui/icons-material/LastPage"
import ControlPointIcon from "@mui/icons-material/ControlPoint"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"
import Paper from "@mui/material/Paper"
import moment from "moment"
import { Avatar, Grid, Container } from "@mui/material/"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { isNewExpression } from "@babel/types"
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete"
import { searchSchool } from "@util/helper"
import ManagerRegiPart from './manager-regi.part';
import ManagerRegiPartName from "./manager-regi.part.name"
import ConfirmDialog from "@components/ConfirmDialog";
import ManagerRegiPartHistory from "@pages/manager/manager-regi.part.history";
import ManagerRegiPartPick from "@pages/manager/manager-regi.part.pick";

import ManagerRegiPartBill from "@pages/manager/manager-regi.part.bill";
import {useParams} from "react-router-dom";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ManagerNoticePartMod from "@pages/manager/manager-notice.part.mod";
import ManagerRegiPartAgency from "@pages/manager/manager-regi.part.agency";
import useAlert from "@hooks/useAlert";
import ManagerAttdncPartBing from "@pages/manager/manager-attdnc.part.bing";

import Tab from "@mui/material/Tab"
import TabList from "@mui/lab/TabList"
import TabContext from "@mui/lab/TabContext"
import TabPanel from "@mui/lab/TabPanel"
import { download } from "@util/helper"
import * as ExcelJS from 'exceljs'
import { useLocation } from "react-router-dom"
import ManagerAttdncPartChoice from "./manager-attdnc.part.choice"
import ManagerAttdncPartMany from "./manager-attdnc.part.many"
import AdjustOutlinedIcon from '@mui/icons-material/AdjustOutlined';
import ManagerAttdncPartSub from "./manager-attdnc.part.sub"
import ManagerAttdncPartDismiss from "./manager-attdnc.part.dismiss"
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import LayersClearIcon from '@mui/icons-material/LayersClear';
/**
 -1 <= phase < 0 : 강좌 데이터 검증 전(특히 파일 업로드 한 경우)
 0 <= phase < 1 : 강좌 데이터 완료
 1 <= phase < 2 : 수강 신청 중
 2 <= phase < 3 : 모집 종료, 학생 선발 전
 3 <= phase < 4 : 학생 선발 후, 등록 중
 4 <= phase < 5 : 등록 마감 강좌 시작 전
 5 <= phase     : 개강준비 완료
 */
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`

const iFormat= 'YYYY-MM-DD HH:mm:ss';
const oFormat= 'MM-DD';
const dayMap = {
  'S001': '월',
  'S002': '화',
  'S003': '수',
  'S004': '목',
  'S005': '금',
  'S006': '토',
  'S007': '일',
}
const statCodeMap = {
  "S000": " ",
  "S001": "○",
  "S200": "X1",
  "S201": "X2",
  "S202": "X3",
  "S203": "X4",
  "S204": "X5",
  "S205": "X6",
  "S206": "X7",
  "S003": "△",
  "S004": "◐",
  "X001": "-",
  "X002": "ⓧ",
}

const greyBg = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'f5f5f5' },
  bgColor: { argb: 'f5f5f5' }
}
const dateFormat2 = "YYYY-MM-DD"
const RLTN_CODE = "S003"
const ManagerAttdncPage = () => {
  console.log("ManagerAttdncPage rendering...")
  const g_sel_code = "SA07"
  const g_stat_code = "SA12"
  const g_week_code = "SB07"
  const {more} = useParams()
  printVariable('more', more)
  const inputRef = useRef()
  const dateFormat = "YYYY-MM-DD HH:mm:ss"
  const [detailScreen, set_detailScreen] = useState(false)
  const [isNew, set_isNew] = useState(false)
  const [schoolList, set_schoolList] = useState([])
  const [teacherList, set_teacherList] = useState([])
  const [smstList, set_smstList] = useState([])
  const [lessonList, set_lessonList] = useState([])
  const [lectureList, set_lectureList] = useState([])
  const [selCodeList, set_selCodeList] = useState([])
  const [statCodeList, set_statCodeList] = useState([])
  const [weekCodeList, set_weekCodeList] = useState([])
  const [tabValue, _set_tabValue] = useState("1")
  const tabValueRef = useRef(tabValue)
  const [onDate, set_onDate] = useState(moment(new Date()).format(dateFormat2))
  const [isCurrent, set_isCurrent] = useState(true)
  // const [onDate, set_onDate] = useState('')
  const originRef = useRef([])

  const location = useLocation()
  const curLocationRef = useRef(location)
  const fields = [
    { field: 'id', placeholder: '데이터번호', type: 'text', value: -1, visible:more && (more === 'more'), canSrch: false, selList: [] },
    { field: 'smstName', placeholder: '년도/기수', type: 'text', value: '', visible: true, canSrch: false, selList: smstList },
    {
      field: 'title',
      placeholder: '강좌명',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'rcrNum',
      placeholder: '모집',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'reqNum',
      placeholder: '신청',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'sttNum',
      placeholder: '등록',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'statName',
      placeholder: '상태',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'userYn',
      placeholder: '저장여부',
      type: 'text',
      value: '',
      visible: onDate && isCurrent,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'startmYn',
      placeholder: '시작알림',
      type: 'text',
      value: '',
      visible: onDate && isCurrent,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'endmYn',
      placeholder: '종료알림',
      type: 'text',
      value: '',
      visible: onDate && isCurrent,
      canSrch: false,
      disabled: false,
      selList: []
    },
    {
      field: 'phase',
      placeholder: '단계',
      type: 'text',
      value: '',
      visible: more && (more === 'more'),
      canSrch: false,
      disabled: false,
      selList: []
    },
  ]
  // const [fields, set_fields] = useState([...defFields])

  const gdnFields = [
    { field: "name", placeholder: "성명" },
    { field: "loginId", placeholder: "ID" },
    { field: "phone", placeholder: "전화번호" },
    { field: "phoneCertYn", placeholder: "인증여부" },
  ]


  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ""))
  const [dataList, set_dataList] = useState({})
  const [schoolGroup, set_schoolGroup] = useState([])

  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 })
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const [selStudentList, set_selStudentList] = useState([])
  const termsRef = useRef(terms)
  const [schoolRowSpan, set_schoolRowSpan] = useState({})
  const [openName, set_openName] = useState(false)
  const [openHistory, set_openHistory] = useState(false)
  const [openPick, set_openPick] = useState(false)
  const [openBill, set_openBill] = useState(false)
  const bingHandler = useState(false)
  const choiceHandler = useState(false)
  const subHandler = useState(false)
  const dismissHandler = useState(false)

  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);


  //
  const recordRef = useRef(defRecord)
  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }

  const handleTabChange = (event, newValue) => {
    tabValueRef.current = newValue 
    _set_tabValue(newValue)

    if(newValue === '2') {
      filterByDate(null)
    }
  }

  const filterByDate = async (date) => {

    let newSmstGroup = {}
    if(date === '' || tabValueRef.current === '2') {
      newSmstGroup = originRef.current
    }
    else {
      Object.keys(originRef.current).forEach(key => {
        const lectureList = originRef.current[key]
        lectureList.forEach(lecture =>  {
          const attdncList = lecture.attdncList.filter(a => (
             moment(a.lectureTime, dateFormat).format(dateFormat2) === date ||
             moment(a.subLectureTime, dateFormat).format(dateFormat2) === date
          ))

          if(attdncList.length > 0) {
            lecture.userYn = attdncList[0].userYn === 'Y' ? 'Y' : 'N'
            lecture.startmYn= attdncList[0].startmYn === 'Y' ? 'Y' : 'N'
            lecture.endmYn= attdncList[0].endmYn === 'Y' ? 'Y' : 'N'
            if(newSmstGroup[key]) {
              newSmstGroup[key].push(lecture)
            }
            else {
              newSmstGroup[key] = [lecture]
            }
          }
        })
      })
    }

    Object.keys(newSmstGroup).forEach(key => {
      const lectures = newSmstGroup[key]
      lectures.sort((a,b) => a.title.localeCompare(b.title))
    })

    set_dataList(newSmstGroup)
    if(onDate !== date && date != null) {
      set_onDate(date)
    }
  }

  const onLoad = async () => {
    const smstGroup = await fetchLecturesWithExtra()
    originRef.current = smstGroup
    console.log('smstGroup=>', smstGroup)
    await filterByDate(onDate)
  }

  const handleDownload = async (lectureId) => {
    const url = `/attdnc/download/${lectureId}`
    await download(url)
  }

  const exportExcel = () => {

  }
  const handleDownload3= async (smstId) => {
    const tmplUrl = `/attdnc/download/tmpl` 
    const response = await axios.get(tmplUrl,{ responseType: 'arraybuffer' })
    const buffer = response.data
    const workbook = new ExcelJS.Workbook()
    await workbook.xlsx.load(new Uint8Array(buffer))
    const firstSheet = workbook.getWorksheet(1)

    const url = `/attdnc/download/excel/smst/${smstId}`
    openIndicator()
    const resp = await WebService.get(url)
    console.log('resp=>', resp)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)


    const smst = JSON.parse(repMessage.smst)
    const lectures = smst.lectures
    lectures.forEach((lecture, idx) => {
      const sheet = workbook.addWorksheet(lecture.title)
      
      firstSheet.eachRow((row, rowNumber) => {
          const newRow = sheet.getRow(rowNumber);
          row.eachCell((cell, colNumber) => {
              // Copy cell value
              newRow.getCell(colNumber).value = cell.value;

              // Copy additional cell properties like styles
              newRow.getCell(colNumber).style = Object.assign({}, cell.style);

              // If there are merged cells, copy the merging information
              if (cell.isMerged) {
                  const merge = firstSheet.getCell(cell.master.address).merge;
                  newRow.getCell(colNumber).merge = Object.assign({},merge);
              }
          });
      });
      

      // Copy header and footer
      sheet.headerFooter = Object.assign({}, firstSheet.headerFooter);

      // Copy other sheet properties (adjust as needed)
      sheet.properties.defaultRowHeight = firstSheet.properties.defaultRowHeight;

      // Copy page layout information
      sheet.pageSetup = Object.assign({}, firstSheet.pageSetup);
      sheet.pageLayout = true
      sheet.views = [
            {
                state: 'normal',
                zoomScale: 80,
                zoomScaleNormal: 80,
                style: 'pageLayout',
            },
        ];
      const lschs = lecture.lschs
      const attdncs = lecture.attdncs
      const teacher = lecture.teacher
      const bings = lecture.bings
      const students= lecture.students

      for (let i = sheet.rowCount; i > 0; i--) {
        sheet.spliceRows(i, 1);
      }

      let schedule = ''
      lschs.forEach(lsch => {
        const day = dayMap[lsch.weekCode]
        const stime = lsch.startTime
        const etime = lsch.endTime
        schedule += `${day} ${stime}~${etime}` 
        schedule +=  ','
      })
      schedule = schedule.endsWith(',') ? schedule.slice(0, -1) : schedule
      const left = `${schola.name} ${smst.year}년 ${smst.gisu}기`
      const center = `늘봄 학교 출석부`
      const right = `${lecture.title} ${teacher.name} ${schedule}`
      
      const header = sheet.headerFooter.oddHeader
      console.log('header=>', header)
      let mtext = header.replace('@LEFT', left);
      mtext = mtext.replace('@CENTER', center );
      mtext = mtext.replace('@RIGHT', right);
      sheet.headerFooter.oddHeader= mtext
      const headerList = [" No. ", " 학년 ", " 반 ", " 번호 ", "  이름  ", "보호자전화번호", "비고"]
      attdncs.forEach((a, idx) => {
        const mmdd = moment(a.lectureTime, iFormat).format(oFormat) 
        headerList.push(mmdd)
      })

      const row = sheet.addRow(headerList)
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = {
          name:'맑은 고딕',
          bold: true
        }
        cell.alignment={horizontal:'center'}
      });
      row.getCell(1).fill = greyBg
      
      students.forEach((student, idx) => {
        const record = [idx+1, student.grade, student.className, student.classNum, student.name, student.gdnPhone, '']
        attdncs.forEach((attdnc, idx2) => {
          const bing = bings.find(r => r.studentId == student.id && r.attdncId === attdnc.id)
          if(bing) {
            record.push(statCodeMap[bing.statCode])
          }
        })
        const row = sheet.addRow(record)
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.font = {
            name:'맑은 고딕',
            size:10,
          }
          cell.alignment={horizontal:'center'}
        });
        row.getCell(1).fill = greyBg
      })

      sheet.columns.forEach((column, colNumber) => {
        /*
        const minLength = 5
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? String(cell.value).length : minLength; // Default width if the cell is empty
          if (columnLength > maxLength) {
              maxLength = columnLength;
          }
        });
        column.width = maxLength < minLength ? minLength : maxLength + 3; // Set a minimum width
        */
        if(colNumber == 0 || colNumber === 1 || colNumber === 2 || colNumber === 3) {
          column.width = 5
        }
        else if(colNumber === 4) {
          column.width = 9
        }
        else if(colNumber === 5) {
          column.width = 15
        }
        else {
          column.width = 7
        }
        
     });

    })

    workbook.removeWorksheet(1)
    workbook.xlsx.writeBuffer().then(buffer => {
      // Create a Blob from the buffer
      // const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const blob = new Blob([buffer], { type: 'application/octet-stream' });

      // Create a download link
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      // Set the download attribute with the desired file name
      link.download = 'example.xlsx';

      // Append the link to the document and trigger a click
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
    });
  }

  const handleDownload2= async (lectureId) => {
    const tmplUrl = `/attdnc/download/tmpl` 
    const response = await axios.get(tmplUrl,{ responseType: 'arraybuffer' })
    const buffer = response.data

    const url = `/attdnc/download/excel/lecture/${lectureId}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const lecture = JSON.parse(repMessage.lecture)
    const smst = JSON.parse(repMessage.smst)
    const lschs = JSON.parse(repMessage.lschs)
    const holidays = JSON.parse(repMessage.holidays)
    const attdncList = JSON.parse(repMessage.attdncList)
    const teacher = JSON.parse(repMessage.teacher)
    const bingList = JSON.parse(repMessage.bingList)
    const studentList = JSON.parse(repMessage.studentList)
  
    const options = {
      useStyles: true 
    }
    // const workbook = new ExcelJS.stream.xlsx.WorkbookWriter(options)
    const workbook = new ExcelJS.Workbook()
    await workbook.xlsx.load(new Uint8Array(buffer))
    const sheet = workbook.getWorksheet(1)
    
    sheet.name = lecture.title
    
    workbook.xlsx.writeBuffer().then(buffer => {
      // Create a Blob from the buffer
      // const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const blob = new Blob([buffer], { type: 'application/octet-stream' });

      // Create a download link
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      // Set the download attribute with the desired file name
      link.download = 'example.xlsx';

      // Append the link to the document and trigger a click
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
    });
    
  }

  const fetchLecturesWithExtra = async() => {

    let url = `/lecture/extra2/${schola.id}`;
    const newTerms = {};

    let tempList;

    openIndicator()
    let resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
    });
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage);
    const originList = JSON.parse(repMessage.records);
    if(repMessage.totalCount) {
      const totalCount = repMessage.totalCount;
      set_totalCount(totalCount);
    }
    const records = originList.reduce((acc, cur, idx, arr) => {
      const lecture = cur.lecture;
      lecture.smstId = cur.smst.id;
      lecture.year = cur.smst.year;
      lecture.gisu = cur.smst.gisu;
      lecture.smstPhase = cur.smst.phase
      lecture.teacherName = cur.teacher.name;
      lecture.userId = cur.teacher.id;
      lecture.statName = findCode(codes, 'SA08', lecture.statCode)?.name ?? ''
      
      acc.push(lecture);
      return acc;
    }, []);

    //
    const smstGroup = records.reduce((acc, cur) => {
      const key = '' + cur.year + '/' + cur.gisu;
      if (acc[key]) {
        acc[key].push(cur);
      } else {
        acc[key] = [cur];
      }
      cur.groupId = key;
      return acc;
    }, {});
    
    return smstGroup
  }


  /*
  const onDetail = async (id) => {
    set_detailScreen(true)
    dgHandler[1](true)
  }


  const onDiscard = async (lectureId) => {
    openIndicator()
    const url = `/lecture/discard/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onStartReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/start/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onQuitReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/quit/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onPauseReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/pause/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }
  */
  const onAttdnc = async(lectureId) => {
    openIndicator()
    const url = `/attdnc/lecture/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('출석부를 생성하였습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onRecover = async(lectureId) => {
    openIndicator()
    const url = `/lecture/recover/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('이전 상태로 복구 되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }

  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label='first page'>
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label='previous page'>
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label='next page'>
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label='last page'>
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  const loadSelStudentList = async (lectureId) => {
    const url = `/regi/sel/student`
    const action = getAction(url, { lectureId: lectureId })
    const resp = await WebService.get(action)

    set_selStudentList([])
    if (resp.repCode === "ack") {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      set_selStudentList(records)
      openSnackbar("선밞/마감하였습니다.")
    }
  }

  const genAttdnc = async (lectureId) => {
    const url = `/attdnc/${lectureId}`
    const action = getAction(url, {})
    const resp = await WebService.post(action)
    if (resp.repCode === "ack") {
      openSnackbar("출석부를 생성하였습니다.")
    } else {
      openSnackbar(resp.repMessage)
    }
  }

  const onCloseBill = async(lectureId) => {
    const url = `/lecture/bill/quit/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if(resp.repCode === 'ack') {
      alert('처리되었습니다.')
      onLoad()
    }
    else {
      alert(resp.repMessage)
    }
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }))

  useEffect(() => {
   if(curLocationRef.current.key !== location.key) {
     curLocationRef.current = location
     set_pageInfo({ pageNum: 0, pageSize: 10 })
   }
  },[location])

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
    const size = window
      .getComputedStyle(inputRef.current, null)
      .getPropertyValue("font-size")

    set_fontSize(size)
  }, [])

  const dg_title = "수강신청 정보"
  const memo_DgContent = useMemo(() => {
    return <ManagerRegiPart />
  }, [recordRef.current, detailScreen])

  const bgColor = (row, col) => {
    if(col.field === 'userYn' || col.field === 'startmYn' || col.field === 'endmYn') {
      if(onDate && row.userYn === 'Y' && row.startmYn === 'Y'  && row.endmYn === 'Y') {
        return gs.colors.attdncGood
      }
      else {
        return gs.colors.attdncBad
      }
    }
    return null
  }

  const Body = ({smstPhase}) =>{
    if (dataList != null) {
      return (
        <div ref={inputRef}>
          <MyDialog
            title={dg_title}
            component={memo_DgContent}
            dialogHandler={dgHandler}
            callback={() => {
              set_detailScreen(false)
              set_isNew(false)
            }}
          />
          {bingHandler[0] ? (<ManagerAttdncPartBing record={recordRef.current} dialogHandler={bingHandler} callback={onLoad} />) : null }
          {choiceHandler[0] ? (<ManagerAttdncPartChoice dialogHandler={choiceHandler} isCurrent={isCurrent} />) : null }
          {subHandler[0] ? (<ManagerAttdncPartSub dialogHandler={subHandler} />) : null }
          {dismissHandler[0] ? (<ManagerAttdncPartDismiss dialogHandler={dismissHandler} />) : null }
          { 
            smstPhase === '1' ? (
              <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                <label style={{marginRight:50, display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                  <input type='radio' 
                    name='onDate' 
                    checked={onDate !== ''}
                    onChange ={(e) => {
                      filterByDate( moment(new Date()).format(dateFormat2))
                    }}
                  /> <Typography variant='body2'>오늘 강좌 출석부</Typography>
                </label>
                <label style={{marginRight:50, display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <input type='radio' 
                    name='onDate' 
                    checked={onDate === ''}
                    onChange={(e) => {
                      filterByDate('')
                    }}
                  /> <Typography variant='body2'>모든 강좌 출석부</Typography> 
                </label>
                <Button variant='contained' size='small' style={{ marginRight: 10 }}
                            startIcon={<AdjustOutlinedIcon/>} 
                            onClick={() => choiceHandler[1](true)}
                >
                  출석부 검색/다운로드
                </Button>
                <Button onClick={() => subHandler[1](true)}
                  variant='contained'
                  style={{marginRight:10}}
                  startIcon={<PublishedWithChangesIcon />}
                >
                  보강수업일 지정
                </Button>
                <Button onClick={() => dismissHandler[1](true)}
                  variant='contained'
                  startIcon={<LayersClearIcon/>}
                >
                  휴강일 지정
                </Button>
              </div>

            ) : (
                <Button variant='contained' size='small' style={{ marginRight: 50 }}
                            startIcon={<AdjustOutlinedIcon/>} 
                            onClick={() => choiceHandler[1](true)}
                >
                  출석부 검색/다운로드
                </Button>
            )
          }
          <div style={{ paddingTop: 20 }}>
            <MUITable sx={{minWidth:1200}}>
              <MyTableHead>
                <TableRow>
                  {fields.map((col, index) => {
                    if (col.visible) {
                      return (
                        <TableCell key={index} size='small'>
                          {col.placeholder}
                          {col.canSrch ? (
                            <Fragment>
                              <TextField
                                label=''
                                variant='outlined'
                                size='small'
                                inputProps={{
                                  style: {
                                    fontSize: "0.875em",
                                    padding: 5,
                                    backgroundColor: "#fff",
                                  },
                                }}
                                value={terms[col.field]}
                                onChange={(e) => {
                                  const newTerms = { ...terms }
                                  newTerms[col.field] = e.target.value
                                  set_terms(newTerms)
                                }}
                              />
                            </Fragment>
                          ) : (
                            <Fragment></Fragment>
                          )}
                        </TableCell>
                      )
                    }
                  })}
  
                  <TableCell size='small' align={'center'}>관리</TableCell>
                </TableRow>
              </MyTableHead>
              <TableBody>
                {
                  Object.keys(dataList).map((groupId, gidx) => (
                    dataList[groupId].findIndex((r) => Math.floor(+r.smstPhase) === +smstPhase) >= 0 ? (
                      <Fragment key={gidx}>
                      <TableRow>
                        <TableCell rowSpan={dataList[groupId].length + 1}>{dataList[groupId].length > 0 ? groupId : "데이터 없음"}</TableCell>
                      </TableRow>
                      {
                        dataList[groupId].map((row, rowIdx) => (
                          <TableRow
                          key={rowIdx}
                          onClick={() => recordRef.current = row}
                        >
                          {
                            fields.map((col, colIdx) => (
                              col.visible && col.field !== 'smstName' ? (
                                <TableCell key={colIdx} style={{backgroundColor:bgColor(row, col)}} >
                                  {row[col.field]}
                                </TableCell>
                              ): null
                            ))
                          }
  
                          <TableCell size='small' align={'center'}>
                            <FlatButton variant='outlined' size='small' style={{ marginRight: 5 }}
                                        onClick={() => bingHandler[1](true)} disabled={row.phase < 5.0}>
                              출석부 보기
                            </FlatButton>
                            {/* <FlatButton variant='outlined' size='small' style={{ marginRight: 5 }} */}
                            {/*             onClick={() => handleDownload(row.id)} disabled={row.phase < 5.0}> */}
                            {/*   출석부 다운로드 */}
                            {/* </FlatButton> */}
                          </TableCell>
                        </TableRow>
                        ))
                      }
                    </Fragment>
                    ) : null
                    
                  ))
                }
  
              </TableBody>
              {/* <TableFooter> */}
              {/*   <TableRow> */}
              {/*     <TablePagination */}
              {/*       rowsPerPageOptions={[{ label: "All", value: -1 }, 10, 20]} */}
              {/*       colSpan={visibleColumns.length + 1} */}
              {/*       count={totalCount} */}
              {/*       rowsPerPage={pageInfo.pageSize} */}
              {/*       page={pageInfo.pageNum} */}
              {/*       SelectProps={{ */}
              {/*         inputProps: { */}
              {/*           "aria-label": "rows per page", */}
              {/*         }, */}
              {/*         native: true, */}
              {/*       }} */}
              {/*       onPageChange={handleChangePage} */}
              {/*       onRowsPerPageChange={handleChangeRowsPerPage} */}
              {/*       ActionsComponent={TablePaginationActions} */}
              {/*       labelDisplayedRows={({ from, to, count }) => { */}
              {/*         return `${from} - ${to} of ${count}` */}
              {/*       }} */}
              {/*       labelRowsPerPage={"페이지당 갯수"} */}
              {/*     /> */}
              {/*   </TableRow> */}
              {/* </TableFooter> */}
            </MUITable>
  
            {renderSnackbar()}
            {renderIndicator()}
            {renderAlert()}
          </div>
        </div>
      )
    }
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}>
        <div style={{ paddingRight: 10 }}>
          <h1>출석현황</h1>
        </div>
      </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          {/* <Button variant='contained' size='small' style={{ marginRight: 50 }} */}
          {/*             startIcon={<AdjustOutlinedIcon/>}  */}
          {/*             onClick={() => choiceHandler[1](true)} */}
          {/* > */}
          {/*   출석부 검색/다운로드 */}
          {/* </Button> */}
        </div>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", position: "sticky", top: 0, backgroundColor: "#fff" }}>
            <TabList onChange={handleTabChange} aria-label='lab API tabs example'>
              <Tab label='현재' value='1' onClick={() => set_isCurrent(true) }  />
              <Tab label='이전내역' value='2'  onClick={() => set_isCurrent(false)}/>
            </TabList>
          </Box>
          <TabPanel value='1' sx={{ minHeight: "60vh" }}>
            <Body smstPhase='1' />
          </TabPanel>
          <TabPanel value='2' sx={{ minHeight: "60vh" }}>
            <Body smstPhase='2' />
          </TabPanel>
        </TabContext>
      </Box>
      <div>
        {openName ? <ManagerRegiPartName record={recordRef.current} open={openName} onClose={() => set_openName(false)} reload={onLoad} /> : null}
        {openPick ? <ManagerRegiPartPick record={recordRef.current} open={openPick} onClose={() => set_openPick(false)} reload={onLoad} /> : null}
        {openBill ? <ManagerRegiPartBill record={recordRef.current} open={openBill} onClose={() => set_openBill(false)} reload={onLoad} /> : null}
        {renderSnackbar()}
        {renderIndicator()}
        {renderAlert()}
      </div>
    </>
  )
}

export default ManagerAttdncPage
